import { CaregiverResponse } from "api";

import { Role, ROLES } from "./types";

export const careGiverRoleConverter = ({ role }: Pick<CaregiverResponse, "role">): Role => {
  switch (role) {
    case "patient_manager":
      return ROLES.PATIENT_MANAGER;
    case "patient_viewer":
      return ROLES.PATIENT_VIEWER;
    case "restricted_user":
      return ROLES.RESTRICTED_USER;
    case "user_manager":
      return ROLES.USER_MANAGER;
    default:
      return ROLES.DASHBOARD_ADMIN;
  }
};
